import { personalTasksSlice } from './slice';
export const { fetchStart, fetchSuccess, createStart, create, createSuccess, createFailure, deleteStart, deleteSuccess, deleteFailed, updateStart, update, updateSuccess, updateFailed } = personalTasksSlice.actions;
export const personalTasksReducer = personalTasksSlice.reducer;
